// import React from 'react';
// import './HomeScreen.css';
// import Navbar from '../Navbar/Navbar';

// const HomeScreen = () => {
//   return (
//     <>
//     <Navbar/>
//     {/* <div className="home-screen">


//       <section className="hero">
//         <div className="hero-content">
//           <h1>Your Member Resource Center</h1>
//           <p>
//             Everything you need to bring your service vision to life—plan projects, grow your club, and become a stronger leader.
//           </p>
//         </div>
//       </section>


//       <section className="quick-links">
//         <h2>Quick Links</h2>
//         <div className="quick-links-grid">
//           {['MISSION 1.5', 'LCIF Grants', 'Lion Portal Updates', 'Logos & Brand', 'Trending Now'].map(link => (
//             <div key={link} className="quick-link-card">{link}</div>
//           ))}
//         </div>
//       </section>


//       <section className="plan-ahead">
//         <h2>Plan Ahead</h2>
//         <ul className="schedule">
//           <li>
//             <span className="date">Jul 01, 2025</span>
//             <span className="desc">New Lion year begins</span>
//           </li>
//           <li>
//             <span className="date">Jul 13-17, 2025</span>
//             <span className="desc">Lions International Convention – Orlando, FL</span>
//           </li>
//           <li>
//             <span className="date">Sep 05-07, 2025</span>
//             <span className="desc">ANZI-Pacific Lions Forum – Gold Coast, Australia</span>
//           </li>
//           <li>
//             <span className="date">Sep 18-20, 2025</span>
//             <span className="desc">USA/Canada Lions Forum – Atlantic City, NJ</span>
//           </li>
//         </ul>
//       </section>

//       <section className="section with-bg learn">
//         <h2>Learn</h2>
//         <p>Explore resources to develop leadership and grow your club.</p>
//       </section>

//       <section className="section with-bg act">
//         <h2>Act</h2>
//         <p>Take action—donate, volunteer, recruit members and join global events.</p>
//       </section>

//       <section className="section with-bg membership">
//         <h2>Membership Mission 1.5</h2>
//         <p>We’re growing to 1.5 million members by 2027. Be part of the movement.</p>
//       </section>

//       <section className="section with-bg lcif">
//         <h2>LCIF Foundation</h2>
//         <p>Help us serve better through grants and global support. Make a difference today.</p>
//       </section>

//       <section className="section with-bg shop">
//         <h2>Lions Shop</h2>
//         <p>Show your pride. Get Lions-branded gear from the Heritage Collection.</p>
//       </section>

//       <section className="section with-bg convention">
//         <h2>International Convention 2025</h2>
//         <p>Join us in Orlando for the biggest Lions event of the year.</p>
//       </section>


//       <section className="contact">
//         <h2>Need Help?</h2>
//         <p>Lions International is here to support you. Reach out anytime.</p>
//         <a href="#" className="button">Contact Us</a>
//       </section>

//     </div> */}


//         <div className="main">
//       <div id="content-area">
//         <article className="node">
//           <div className="content">
//             {/* Hero Banner */}
//             <section className="component-custom-slick-slider">
//               <div className="regular slider hero_banner_height_70" data-rotation="false" data-interval="3000">
//                 <div className="banner-slider hero_banner_height_70">
//                   <div className="carousel-video">
//                     <video
//                       playsInline
//                       preload="auto"
//                       autoPlay
//                       loop
//                       muted
//                       src="/sites/default/files/2024-01/Lions%20International%20Brand%20Web%20No%20Audio.mp4"
//                     ></video>
//                   </div>
//                   <div className="carousel-image carousel-desktop-image" style={{ backgroundImage: 'url()' }}></div>
//                   <div className="carousel-image carousel-mobile-image" style={{ backgroundImage: 'url()' }}></div>
//                   <div className="carousel-caption">
//                     <div className="caption-content text-align text-align-center">
//                       <h1 className="banner-title-medium" style={{ color: '#FFFFFF' }}>
//                         We are serving a world in need.
//                       </h1>
//                       <p className="yellow-large">One act of kindness at a time.</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </section>

//             {/* Stats Cards */}
//             <section className="paragraph paragraph--type--counter-stats-cards">
//               <div className="container">
//                 <h2 className="border-yellow">Making a global impact</h2>
//                 <div className="row m-0">
//                   {[
//                     { number: '1.4', label: 'million', text: 'Lions serving', bg: 'bg-secondary-d5-navy' },
//                     { number: '49,000', label: '', text: 'Lions clubs', bg: 'bg-secondary-d7-violet' },
//                     { number: '200', label: '', text: 'countries and regions served', bg: 'bg-primary-d2-blue' },
//                     { number: '1.2', label: 'US$', text: 'in grants', bg: 'bg-gradient' },
//                   ].map((stat, i) => (
//                     <div className={`col-xl col-lg-6 stats-card-column ${stat.bg}`} key={i}>
//                       <div className="card-number-stats">
//                         <div className="number-stats-group text-primary-d1-yellow">
//                           <div className="number-stats">
//                             {stat.label && <span>{stat.label}</span>}
//                             <span className="odometer">{stat.number}</span>
//                           </div>
//                           <p>{stat.label === 'US$' ? 'billion' : ''}</p>
//                         </div>
//                         <div className="card-text text-white">
//                           <p>{stat.text}</p>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </section>

//             {/* Photo Lockups */}
//             {[
//               {
//                 title: 'Uniting for good',
//                 text: 'Lions and Leos make a difference every day...',
//                 link: '/en/about-us/our-organization/about-lions-international',
//                 image: '/sites/default/files/styles/photo_lockup/public/2023-09/Uniting%20for%20Good.png?itok=UWFT_15o',
//                 accent: 'bg-primary-d2-blue',
//               },
//               {
//                 title: 'Serving with purpose',
//                 text: 'Lions serve their local communities...',
//                 link: '/en/our-impact/our-service/ways-we-serve',
//                 image: '/sites/default/files/styles/photo_lockup/public/2023-09/Serving%20Together.png?itok=NkzKo-0x',
//                 accent: 'bg-secondary-d7-violet',
//               },
//               {
//                 title: 'Leading the way',
//                 text: 'Lions Clubs International President Fabrício Oliveira...',
//                 link: '/en/discover-our-clubs/presidential-theme',
//                 image: '/sites/default/files/styles/photo_lockup/public/2024-06/IP%20Fabricio%20components%20Mountain%20%282%29.jpg?itok=7GeSjfKa',
//                 accent: 'bg-secondary-d8-spearmint',
//               },
//             ].map((block, i) => (
//               <section className="component-photo-lockup bg-light-gray pad-top-lg" key={i}>
//                 <div className="container">
//                   <div
//                     className={`wrapper ${i % 2 === 0 ? 'block-right' : 'block-left'}`}
//                     style={{ backgroundImage: `url(${block.image})` }}
//                   >
//                     <div className="accent">
//                       <div className={`layer layer1 ${block.accent}`}></div>
//                       <div className={`layer layer2 ${block.accent}`}></div>
//                       <div className={`layer layer3 ${block.accent}`}></div>
//                     </div>
//                     <div className="container">
//                       <div className="row">
//                         <div className={`block-wrapper col-md-12 col-lg-5 offset-lg-${i % 2 === 0 ? 6 : 1}`}>
//                           <h3>{block.title}</h3>
//                           <div className="separator"></div>
//                           <p>{block.text}</p>
//                           <a href={block.link} className={`btn ${block.accent}`}>
//                             Learn more
//                           </a>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </section>
//             ))}

//             {/* Join Us */}
//             <section className="component-three-column-tile pad-top-lg">
//               <div className="container-xl">
//                 <div className="container">
//                   <h3>Join us.</h3>
//                   <div className="separator"></div>
//                   <div className="row tile-slider">
//                     {[
//                       {
//                         title: 'Member experience',
//                         image: '/sites/default/files/2023-09/Member%20Experiences%20577x280.png',
//                         link: '/en/join',
//                         flag: 'bg-secondary-d8-spearmint',
//                       },
//                       {
//                         title: 'Club & membership types',
//                         image: '/sites/default/files/2023-09/membership-club-types2%20%281%29.jpg',
//                         link: '/en/node/14991',
//                         flag: 'bg-secondary-d4-cornflower',
//                       },
//                     ].map((tile, i) => (
//                       <div className="col-md-6" key={i}>
//                         <a className="tile-block-link" href={tile.link}>
//                           <div className="tile">
//                             <div
//                               className="tile-image show-overlay"
//                               style={{ backgroundImage: `url(${tile.image})` }}
//                             >
//                               <div className="tile-overlay"></div>
//                               <div className={`flag ${tile.flag}`}>
//                                 <div className="text">Learn more</div>
//                               </div>
//                             </div>
//                             <h4 className="tile-caption">{tile.title}</h4>
//                             <div className="read-more">READ MORE</div>
//                           </div>
//                         </a>
//                       </div>
//                     ))}
//                   </div>
//                   <div className="cta">
//                     <a href="/en/start-our-approach/club-locator" className="btn transparent border-white">
//                       Find a club
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </section>

//             {/* Social Media Section */}
//             <section className="component-title-body html-only pad-top-lg" style={{ backgroundColor: '#ffffff' }}>
//               <div className="container">
//                 <div className="row">
//                   <div className="col-sm-12 col-md-10 offset-md-1">
//                     <h3>Follow our progress.</h3>
//                     <div className="separator"></div>
//                     <p>
//                       Join our conversation on <a href="/en/node/17571">social media</a> and see the difference
//                       we’re making around the world.
//                     </p>

//                     {/* Social Icons */}
//                     <div className="row d-flex justify-content-left">
//                       {[
//                         {
//                           url: 'https://www.facebook.com/lionsclubs/',
//                           image:
//                             'https://www.lionsclubs.org/sites/default/files/2023-09/Facebook%20LI%20circle.jpg',
//                           label: 'Lions Clubs International',
//                         },
//                         {
//                           url: 'https://www.facebook.com/LCIFLions/',
//                           image:
//                             'https://www.lionsclubs.org/sites/default/files/2023-09/Facebook%20LCIF%20circle.jpg',
//                           label: 'Lions Clubs International Foundation',
//                         },
//                         {
//                           url: 'https://www.instagram.com/lionsclubs/',
//                           image:
//                             'https://www.lionsclubs.org/sites/default/files/2023-09/Instagram%20circle%202.jpg',
//                         },
//                         {
//                           url: 'https://twitter.com/lionsclubs',
//                           image:
//                             'https://www.lionsclubs.org/sites/default/files/2023-09/Twitter%20circle.jpg',
//                         },
//                         {
//                           url: 'https://www.linkedin.com/company/lions-clubs-international',
//                           image:
//                             'https://www.lionsclubs.org/sites/default/files/2023-09/LinkedIn%20circle.jpg',
//                         },
//                         {
//                           url: 'https://youtube.com/lionsclubs',
//                           image:
//                             'https://www.lionsclubs.org/sites/default/files/2023-09/YouTube%20circle.jpg',
//                         },
//                       ].map((icon, i) => (
//                         <div className="col-sm-4 col-md-2 col-lg-1 text-align-center" key={i}>
//                           <a href={icon.url} target="_blank" rel="noopener noreferrer">
//                             <img src={icon.image} alt="" width="60%" />
//                           </a>
//                           {icon.label && <h6 style={{ marginTop: '10px' }}>{icon.label}</h6>}
//                         </div>
//                       ))}
//                     </div>

//                     {/* Embed Walls.io Script */}
//                     <div className="walls-io">
//                       <script
//                         id="wallsio-widget-script"
//                         src="https://walls.io/js/wallsio-widget-1.2.js"
//                         data-wallurl="https://walls.io/j7aqx?nobackground=1&amp;show_header=0&amp;initial_posts=6"
//                         data-width="100%"
//                         data-autoheight="1"
//                         data-injectloadmorebutton="1"
//                         data-loadmoretext="See More"
//                         data-height="800"
//                         data-lazyload="1"
//                       ></script>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </section>
//           </div>
//         </article>
//       </div>
//     </div>
//     </>
//   );
// };

// export default HomeScreen;
// import React from 'react';
// import './HomeScreen.css';

// const HomeScreen = () => {
//   return (
//     <div className="home-container">

//       {/* Hero Section */}
//       <section className="hero">
//         <div className="hero-overlay">
//           <h1>We are serving a world in need.</h1>
//           <p>One act of kindness at a time.</p>
//           <button className="cta-button">Learn More</button>
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section className="stats-section">
//         <h2>Making a global impact</h2>
//         <div className="stats-grid">
//           <div className="stat-card navy">
//             <h3>1.4<span> million</span></h3>
//             <p>Lions serving</p>
//           </div>
//           <div className="stat-card violet">
//             <h3>49,000</h3>
//             <p>Lions clubs</p>
//           </div>
//           <div className="stat-card blue">
//             <h3>200</h3>
//             <p>countries and regions served</p>
//           </div>
//           <div className="stat-card gradient">
//             <h3>US$ 1.2<span> billion</span></h3>
//             <p>in grants</p>
//           </div>
//         </div>
//       </section>

//       {/* About / Info Section */}
//       <section className="info-section" style={{ backgroundImage: 'url(/assets/uniting.jpg)' }}>
//         <div className="info-overlay">
//           <h3>Uniting for good</h3>
//           <p>Lions and Leos make a difference every day, everywhere we serve. Together we’re changing lives, communities and the world we share.</p>
//           <a href="/en/about-us/our-organization/about-lions-international" className="info-button">Learn More</a>
//         </div>
//       </section>

//       {/* Service Section */}
//       <section className="info-section reverse" style={{ backgroundImage: 'url(/assets/serving.jpg)' }}>
//         <div className="info-overlay">
//           <h3>Serving with purpose</h3>
//           <p>Lions serve their local communities and unite for global causes to address the world’s greatest challenges.</p>
//           <a href="/en/our-impact/our-service/ways-we-serve" className="info-button">Learn More</a>
//         </div>
//       </section>

//       {/* Leadership Section */}
//       <section className="info-section" style={{ backgroundImage: 'url(/assets/leadership.jpg)' }}>
//         <div className="info-overlay">
//           <h3>Leading the way</h3>
//           <p>Meet Lions Clubs International President Fabrício Oliveira and learn about his vision for the future of service.</p>
//           <a href="/en/discover-our-clubs/presidential-theme" className="info-button">Learn More</a>
//         </div>
//       </section>

//       {/* Social Media Section */}
//       <section className="social-section">
//         <h3>Follow our progress.</h3>
//         <p>Join the conversation and see the difference we’re making around the world.</p>
//         <div className="social-icons">
//           {[
//             { url: 'https://facebook.com/lionsclubs', img: '/assets/facebook1.jpg' },
//             { url: 'https://facebook.com/LCIFLions', img: '/assets/facebook2.jpg' },
//             { url: 'https://instagram.com/lionsclubs', img: '/assets/instagram.jpg' },
//             { url: 'https://twitter.com/lionsclubs', img: '/assets/twitter.jpg' },
//             { url: 'https://linkedin.com/company/lions-clubs-international', img: '/assets/linkedin.jpg' },
//             { url: 'https://youtube.com/lionsclubs', img: '/assets/youtube.jpg' }
//           ].map((icon, i) => (
//             <a href={icon.url} target="_blank" rel="noopener noreferrer" key={i}>
//               <img src={icon.img} alt={`social-${i}`} />
//             </a>
//           ))}
//         </div>
//       </section>

//     </div>
//   );
// };

// export default HomeScreen;




// import React, { useEffect, useState } from 'react';
// import './HomeScreen.css';

// const StatCard = ({ label, target, suffix = '', prefix = '', duration = 2000 }) => {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     let start = 0;
//     const startTime = performance.now();

//     const updateCount = (timestamp) => {
//       const progress = Math.min((timestamp - startTime) / duration, 1);
//       const current = Math.floor(progress * target);
//       setCount(current);
//       if (progress < 1) requestAnimationFrame(updateCount);
//       else setCount(target);
//     };

//     requestAnimationFrame(updateCount);
//   }, [target, duration]);

//   return (
//     <div className="stat-card">
//       <h3>
//         {prefix}
//         {count.toLocaleString()}
//         {suffix}
//       </h3>
//       <p>{label}</p>
//     </div>
//   );
// };

// const Home = () => {
//   return (
//     <div className="home-container">

//       {/* Hero Section */}
//       <section className="hero">
//         <div className="hero-overlay">
//           <h1>We are serving a world in need.</h1>
//           <p>One act of kindness at a time.</p>
//           <button className="cta-button">Learn More</button>
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section className="stats-section">
//         <h2>Making a global impact</h2>
//         <div className="stats-grid">
//           <StatCard label="Lions serving" target={1400000} suffix=" million" />
//           <StatCard label="Lions clubs" target={49000} />
//           <StatCard label="countries and regions served" target={200} />
//           <StatCard label="in grants" target={1.2} prefix="US$ " suffix=" billion" />
//         </div>
//       </section>

//     </div>
//   );
// };

// export default Home;


// import React, { useEffect, useState } from 'react';
// import './HomeScreen.css';
// import Navbar from '../Navbar/Navbar';

// const StatCard = ({ label, target, suffix = '', prefix = '', duration = 2000 }) => {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     const startTime = performance.now();

//     const update = (timestamp) => {
//       const progress = Math.min((timestamp - startTime) / duration, 1);
//       const value = Math.floor(progress * target);
//       setCount(value);
//       if (progress < 1) requestAnimationFrame(update);
//     };

//     requestAnimationFrame(update);
//   }, [target, duration]);

//   const displayNumber = target >= 1000000
//     ? `${(count / 1000000).toFixed(1)}`
//     : count.toLocaleString();

//   return (
//     <div className="stat-card">
//       <h3>
//         {prefix}{displayNumber}{suffix}
//       </h3>
//       <p>{label}</p>
//     </div>
//   );
// };

// const HomeScreen = () => {
//   return (
//     <>
//     <Navbar />
//     <div className="home-container">

//       {/* Hero Section */}
// <section className="hero">
//   <div className="hero-overlay">
//     <h1>We are serving a world in need.</h1>
//     <p>One act of kindness at a time.</p>
//     <button className="cta-button">Learn More</button>
//   </div>
// </section>

//       {/* Stats Section */}
//       <section className="stats-section">
//         <h2>Making a global impact</h2>
//         <div className="stats-grid">
//           <StatCard label="Lions serving" target={1400000} suffix=" million" />
//           <StatCard label="Lions clubs" target={49000} />
//           <StatCard label="Countries and regions served" target={200} />
//           <StatCard label="In grants" target={1.2} prefix="US$ " suffix=" billion" />
//         </div>
//       </section>
//     </div>
//     </>

//   );
// };

// export default HomeScreen;


import React, { useEffect, useRef, useState } from 'react';
import Odometer from 'odometer';
import 'odometer/themes/odometer-theme-default.css';
import './HomeScreen.css';

import axios from 'axios'; // Added axios for API call

import impact1 from '../images/sc/Screenshot_18-8-2025_161231_.jpeg';
import impact2 from '../images/sc/Screenshot_18-8-2025_161323_.jpeg';
import impact3 from '../images/sc/Screenshot_18-8-2025_16139_.jpeg';

import { translateText } from "../Navbar/Navbar"; // reuse helper
import { useNavigate } from 'react-router-dom';

const StatCard = ({ label, value, prefix = '', suffix = '' }) => {
  const ref = useRef();

  useEffect(() => {
    const od = new Odometer({
      el: ref.current,
      value: 0,
      format: '(,ddd)',
      theme: 'default',
      duration: 500,
    });
    setTimeout(() => {
      od.update(value);
    }, 300);
  }, [value]);

  return (
    <div className="stat-card rich">
      <div className="stat-number">
        {prefix}
        <span ref={ref}></span>
        {suffix}
      </div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

const HomeScreen = ({ selectedLang }) => {
  // State for dynamic database banners & carousel index
  const [banners, setBanners] = useState([]);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);

  // Fetch banners from API
  useEffect(() => {
    axios.get('https://lcoiapi.emedha.in/appi/home-banners')
      .then(response => {
        if (response.data && response.data.length > 0) {
          // Map and ensure image_url exists even if backend returns plain filenames
          const formattedBanners = response.data.map(item => ({
            ...item,
            image_url: item.image_url || `https://lcoiapi.emedha.in/images/${item.image}`
          }));
          setBanners(formattedBanners);
        }
      })
      .catch(error => console.error("Error fetching banners:", error));
  }, []);

  // Auto-scroll dynamic banner carousel every 5 seconds
  useEffect(() => {
    if (banners.length === 0) return;
    const bannerInterval = setInterval(() => {
      setCurrentBannerIndex(prev => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(bannerInterval);
  }, [banners]);

  const [translated, setTranslated] = useState({
    heroTitle: "",
    heroPara: "",
    highlight: "",
    quote: "",
    stats: {},
    services: [],
    impacts: [],
    globalImpact: "",
    serveIndia: "",
    serveDesc: "",
    servButton: "",
    isameForumTitle: "",
    isameForumDesc: "",
    sheSakthiTitle: '',
    sheSakthiDesc: "",
    eWasteDriveTitle: "",
    eWasteDriveDesc: "",
    allIndiaSchoolingTitle: "",
    allIndiaSchoolingDesc: "",
    servicess: '',
    OurImpact: "",
  });

  const services = [
    {
      title: "Childhood Cancer",
      description: "Lions provide support for the needs of children affected by childhood cancer through impactful service activities....",
      icon: "🎗️",
    },
    {
      title: "Diabetes",
      description: "Lions, with the support of Lions Clubs International Foundation (LCIF), are working to reduce the prevalence of diabetes....",
      icon: "🩺",
    },
    {
      title: "Environment",
      description: "The earth sustains human life. We've seen how our stewardship of natural resources can improve quality of life....",
      icon: "🌿",
    },
    {
      title: "Hunger",
      description: "We strive to improve human flourishing. We see how the global hunger and nutrition crisis impact our most vulnerable communities...",
      icon: "🍽️",
    },
    {
      title: "Vision",
      description: "Lions are known throughout the world for their work to improve the lives of the visually impaired and prevent...",
      icon: "👁️",
    },
    {
      title: "Humanitarian",
      description: "The humanitarian efforts of Lions have been notable and celebrated for more than 100 years. Working together...",
      icon: "🤝",
    }
  ];

  const impacts = [
    {
      title: "Lions serve youth",
      description: "Our community projects often support children and local schools through scholarships, recreation and mentoring. Internationally, we offer many programs...",
      image: impact1,
      badge: "FOUNDATION OF SERVICE",
    },
    {
      title: "Lions serve",
      description: "Our motto is 'We Serve'. Founded in 1917, we care best known for saving sight, but we also feed the...",
      image: impact2,
      badge: "HEART OF SERVICE",
    },
    {
      title: "Lions give sight",
      description: "By conducting vision screenings, equipping hospitals and clinics, distributing medicine and raising awareness of eye disease, Lions work toward...",
      image: impact3,
      badge: "CELEBRATING 20 YEARS",
    }
  ];

  useEffect(() => {
    if (!selectedLang) return;
    async function translateAll() {
      const englishTexts = {
        heroTitle: "Every time we serve, our roots grow stronger and deeper.",
        heroPara: "Service is the foundation of Lions. It’s who we are and what we do. ",
        highlight: "Our roots run deep — stretching far and wide to build lasting connections and strengthen our world.",

        stats: {
          lionsServing: "Lions serving",
          lionsClubs: "Lions clubs",
          countries: "Countries and regions served",
          grants: "In grants",
        },
        globalImpact: "Making a global impact",
        servicess: 'Services',
        OurImpact: "Our Impact",
        serveIndia: "WE SERVE INDIA",
        serveDesc: "We Serve India – Season 3 is a flagship social impact initiative by Forbes India, in association with CNN-News18 and Lions Clubs International, recognising individuals and organisations creating meaningful impact across India. This season, changemakers will be recognised across four categories — Education & Skills Transformation, Healthcare & Accessibility, Environmental Sustainability & Climate Resilience, and Community Resilience & Disaster Relief",
        servButton: "Learn more",
        isameForumTitle: "ISAME Forum 2026",
        isameForumDesc: "Lions Clubs International is the world's largest service club organisation with 14 lakh members in over 210 countries and geographical areas of the world. For administrative purpose the world of Lions is divided into eight constitutional areas....",
        eWasteDriveTitle: "E-Waste Collection Drive",
        eWasteDriveDesc: "From October 15th to November 14th, 2024, we're launching the massive 'Dump or Donate' campaign to raise awareness about responsible e-waste disposal. But that's not all – the world's biggest collection drive follows from November 15th to December 14th, 2025. Let's spread the word far and wide! Stay tuned for updates on how you can be part of this impactful movement....",
        allIndiaSchoolingTitle: "All India Schooling",
        allIndiaSchoolingDesc: "The 2027 DGE Team All India schooling will be held from 1stJune  to 5th June 2027 at ITC Grand Chola Chennai . The schooling chairperson is ID Pankaj Mehta and the Schooling coordinators will be PID R.Mathanagopal and PID R.Sampath .",
      };

      const translatedServices = await Promise.all(
        services.map(async (s) => ({
          ...s,
          title: await translateText(s.title, selectedLang),
          description: await translateText(s.description, selectedLang),
        }))
      );

      const translatedImpacts = await Promise.all(
        impacts.map(async (i) => ({
          ...i,
          title: await translateText(i.title, selectedLang),
          description: await translateText(i.description, selectedLang),
          badge: await translateText(i.badge, selectedLang),
        }))
      );

      const translatedStats = {
        lionsServing: await translateText(englishTexts.stats.lionsServing, selectedLang),
        lionsClubs: await translateText(englishTexts.stats.lionsClubs, selectedLang),
        countries: await translateText(englishTexts.stats.countries, selectedLang),
        grants: await translateText(englishTexts.stats.grants, selectedLang),
      };

      setTranslated({
        heroTitle: await translateText(englishTexts.heroTitle, selectedLang),
        heroPara: await translateText(englishTexts.heroPara, selectedLang),
        highlight: await translateText(englishTexts.highlight, selectedLang),
        quote: await translateText(englishTexts.quote, selectedLang),
        globalImpact: await translateText(englishTexts.globalImpact, selectedLang),
        serveIndia: await translateText(englishTexts.serveIndia, selectedLang),
        serveDesc: await translateText(englishTexts.serveDesc, selectedLang),
        servButton: await translateText(englishTexts.servButton, selectedLang),
        servicess: await translateText(englishTexts.servicess, selectedLang),
        OurImpact: await translateText(englishTexts.OurImpact, selectedLang),
        isameForumTitle: await translateText(englishTexts.isameForumTitle, selectedLang),
        isameForumDesc: await translateText(englishTexts.isameForumDesc, selectedLang),
        sheSakthiTitle: await translateText(englishTexts.sheSakthiTitle, selectedLang),
        sheSakthiDesc: await translateText(englishTexts.sheSakthiDesc, selectedLang),
        eWasteDriveTitle: await translateText(englishTexts.eWasteDriveTitle, selectedLang),
        eWasteDriveDesc: await translateText(englishTexts.eWasteDriveDesc, selectedLang),
        allIndiaSchoolingTitle: await translateText(englishTexts.allIndiaSchoolingTitle, selectedLang),
        allIndiaSchoolingDesc: await translateText(englishTexts.allIndiaSchoolingDesc, selectedLang),
        services: translatedServices,
        impacts: translatedImpacts,
        stats: translatedStats,
      });
    }

    translateAll();
  }, [selectedLang]);

  const navigate = useNavigate();

  const handleDownload = async () => {
    try {
      const fileUrl = `${process.env.PUBLIC_URL}/president_theme.pdf`;
      const response = await fetch(fileUrl);
      const contentType = response.headers.get('content-type');
      if (!response.ok || (contentType && contentType.includes('text/html'))) {
        alert('PDF file not found in the public folder!');
        return;
      }
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'president_theme.pdf';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download error:', error);
    }
  };

  // Fallback current banner properties if API data is loading/empty
  const currentBanner = banners.length > 0 ? banners[currentBannerIndex] : {
    title: translated.heroTitle,
    description: translated.heroPara,
    button_name: "",
    button_url: "",
    image_url: ""
  };
  const handlePrev = () => {
    setCurrentBannerIndex((prevIndex) => (prevIndex === 0 ? banners.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentBannerIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  return (
    <>
      <div className="home-container">

        {/* Dynamic Hero Carousel Section with Inline Styles Only */}
        <section style={{
          position: 'relative',
          width: '100%',
          height: '550px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          backgroundColor: '#333'
        }}>
          {/* Dynamic Background Image */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${currentBanner.image_url || `https://lcoiapi.emedha.in/images/${currentBanner.image}`})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: 1,
            transition: 'background-image 0.5s ease-in-out'
          }}></div>

          {/* Dark Overlay for Readability */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            zIndex: 2
          }}></div>

          {/* Hero Overlay Text Content */}
          <div style={{
            position: 'relative',
            zIndex: 3,
            color: '#fff',
            textAlign: 'center',
            maxWidth: '850px',
            padding: '0 20px'
          }}>
            <h1 onClick={handleDownload} style={{ cursor: 'pointer', fontSize: '2.4rem', marginBottom: '15px' }}>
              {currentBanner.title}
            </h1>
            <p style={{ fontSize: '1.1rem', marginBottom: '20px', whiteSpace: 'pre-line' }}>
              {currentBanner.description}
            </p>
            {currentBanner.button_name && (
              <a
                href={currentBanner.button_url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '10px 25px',
                  backgroundColor: '#ffaa00',
                  color: '#fff',
                  textDecoration: 'none',
                  borderRadius: '4px',
                  fontWeight: 'bold',
                  marginBottom: '15px'
                }}
              >
                {currentBanner.button_name}
              </a>
            )}
            <p style={{ fontSize: '0.95rem', fontStyle: 'italic', opacity: '0.9' }}>
              {translated.highlight}
            </p>
          </div>

          {/* Hero Person / Quote */}
          <div style={{
            position: 'absolute',
            bottom: '40px',
            left: '20px',
            zIndex: 3,
            color: '#fff'
          }}>
            <blockquote>{translated.quote}</blockquote>
          </div>

          {/* Left Arrow Button */}
          {banners.length > 1 && (
            <button
              onClick={handlePrev}
              style={{
                position: 'absolute',
                left: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 4,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                color: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: '45px',
                height: '45px',
                fontSize: '20px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              &#10094;
            </button>
          )}

          {/* Right Arrow Button */}
          {banners.length > 1 && (
            <button
              onClick={handleNext}
              style={{
                position: 'absolute',
                right: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 4,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                color: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: '45px',
                height: '45px',
                fontSize: '20px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              &#10095;
            </button>
          )}

          {/* Carousel Indicator Dots */}
          {banners.length > 1 && (
            <div style={{
              position: 'absolute',
              bottom: '15px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 3,
              display: 'flex',
              gap: '8px'
            }}>
              {banners.map((_, index) => (
                <span
                  key={index}
                  onClick={() => setCurrentBannerIndex(index)}
                  style={{
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    backgroundColor: currentBannerIndex === index ? '#fff' : 'rgba(255, 255, 255, 0.5)',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s'
                  }}
                ></span>
              ))}
            </div>
          )}
        </section>

        <section className="container stats-section rich-ui">
          <h2>{translated.globalImpact}</h2>
          <div className="stats-grid">
            <StatCard label={translated.stats.lionsServing} value={1370000} suffix=" million" />
            <StatCard label={translated.stats.lionsClubs} value={50094} />
            <StatCard label={translated.stats.countries} value={200} />
            <StatCard label={translated.stats.grants} value={1.2} prefix="US$ " suffix=" billion" />
          </div>
        </section>

        <section className="info-section" style={{ backgroundColor: '#9c61a6' }}>
          <div className="info-content">
            <div className="info-image img1"></div>
            <div className="info-text">
              <h2 style={{ color: 'white' }}>{translated.serveIndia}</h2>
              <p style={{ color: 'white' }}>{translated.serveDesc}</p>
              <button
                className="info-button"
                onClick={() => navigate("/serve-india")}
              >
                {translated.servButton}
              </button>

            </div>
          </div>
        </section>

        <section className="info-section" style={{ backgroundColor: '#356f71' }}>
          <div className="info-content reverse">
            <div className="info-image img2"></div>
            <div className="info-text">
              <h2 style={{ color: 'white' }}>{translated.isameForumTitle}</h2>
              <p style={{ color: 'white' }}>{translated.isameForumDesc}</p>
              <button onClick={() => window.open('https://isameforum2026.com/', '_blank')} className="info-button purple">
                {translated.servButton}
              </button>
            </div>
          </div>
        </section>

        <section className="info-section" style={{ backgroundColor: '#f0c351' }}>
          <div className="info-content reverse">
            <div className="info-image img4"></div>
            <div className="info-text">
              <h2 style={{ color: 'white' }}>{translated.eWasteDriveTitle}</h2>
              <p style={{ color: 'white' }}>{translated.eWasteDriveDesc}</p>
              <button className="info-button purple">{translated.servButton}</button>
            </div>
          </div>
        </section>

        <section className="info-section" style={{ backgroundColor: '#e77946' }}>
          <div className="info-content">
            <div className="info-image img5"></div>
            <div className="info-text">
              <h2 style={{ color: 'white' }}>{translated.allIndiaSchoolingTitle}</h2>
              <p style={{ color: 'white' }}>{translated.allIndiaSchoolingDesc}</p>
              <button className="info-button green">{translated.servButton}</button>
            </div>
          </div>
        </section>

        <div className="outer-container">
          <h2 className="section-title">{translated.servicess}</h2>
          <div className="services-grid">
            {translated.services.map((service, index) => (
              <div className="service-card" key={index}>
                <div className="service-icon">{service.icon}</div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            ))}
          </div>

          <div className='bgg' style={{ marginBottom: "30px", marginTop: '30px' }}>
            <h2 className="section-title">{translated.OurImpact}</h2>
            <div className="impact-grid">
              {translated.impacts.map((impact, index) => (
                <div className="impact-card" key={index}>
                  <div className="impact-image-wrapper">
                    <img src={impact.image} alt={impact.title} className="impact-image" />
                    <div className="impact-badge">{impact.badge}</div>
                  </div>
                  <h3 className="impact-title">{impact.title}</h3>
                  <p className="impact-description">{impact.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <section style={{ background: "#f5f5f5", padding: "40px 0" }}>
        <div
          style={{
            width: "90%",
            margin: "auto",
            background: "#fff",
            padding: "30px",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ fontWeight: "bold" }}>Follow our progress.</h2>
          <div
            style={{
              width: "70px",
              height: "4px",
              background: "#f9c910",
              margin: "10px 0 20px 0",
            }}
          ></div>
          <p>
            Join our conversation on social media and see the difference we’re making around the world.
          </p>

          <div style={{ display: "flex", gap: "25px", marginTop: "20px" }}>
            <a href="https://www.facebook.com/people/Lions-Council-Of-India/100087045017331/" target="_blank" rel="noreferrer">
              <img src="https://www.lionsclubs.org/sites/default/files/2023-09/Facebook%20LI%20circle.jpg" width="50" alt="FB" />
            </a>
            <a href="https://www.instagram.com/" target="_blank" rel="noreferrer">
              <img src="https://www.lionsclubs.org/sites/default/files/2023-09/Instagram%20circle%202.jpg" width="50" alt="Insta" />
            </a>
            <a href="https://twitter.com/" target="_blank" rel="noreferrer">
              <img src="https://www.lionsclubs.org/sites/default/files/2023-09/Twitter%20circle.jpg" width="50" alt="Twitter" />
            </a>
            <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer">
              <img src="https://www.lionsclubs.org/sites/default/files/2023-09/LinkedIn%20circle.jpg" width="50" alt="LinkedIn" />
            </a>
            <a href="https://youtube.com/" target="_blank" rel="noreferrer">
              <img src="https://www.lionsclubs.org/sites/default/files/2023-09/YouTube%20circle.jpg" width="50" alt="YouTube" />
            </a>
          </div>

          <div id="wallsio-container" style={{ marginTop: "30px" }}></div>
        </div>
      </section>
    </>
  );
};

export default HomeScreen;
